export default __webpack_public_path__ + "static/media/img-cwa-user-experience-02.38eaef35.png";